export const offeringConfig = {
  WeWork: {
    partnerSlug: "wework",
    slugConfig: {
      dayPass: "wework-daypass",
      multiPass: "wework-multi-pass",
      dailyAccess: "wework-daily-access",
      dayOffice: "wework-day-office",
      meetingRoom: "wework-meeting-rooms",
      classroom: "wework-classrooms",
    },
  },
  Mindspace: {
    slugConfig: {
      multiPass: "mindspace-multi",
      dayPass: "mindspace-daily",
      dayPassGermany: "mindspace-daily-germany",
      dayOffice: "mindspace-daily-office",
      dayOfficeGermany: "mindspace-daily-office-germany",
      meetingRooms: "mindspace-meeting-rooms",
    },
  },
  Nomadworks: {
    slugConfig: {
      dayPass: "nomadworks-day-pass",
      multiPass: "nomadworks-multi-pass",
      dayOffice: "nomadworks-day-office",
      meetingRoom: "nomadworks-meeting-rooms",
    },
  },
  BrainEmbassyNew: {
    slugConfig: {
      dayPass: "brain-embassy-day-pass",
      multiPass: "brain-embassy-multi",
      dayOffice: "brain-embassy-day-office",
      meetingRooms: "brain-embassy-meeting-rooms",
    },
  },
  Werqwise: {
    slugConfig: {
      dayPass: "werqwise-day-pass",
      multiPass: "werqwise-multi-pass",
      dayOffice: "werqwise-day-office",
      meetingRoom: "werqwise-meeting-rooms",
    },
  },
  TheYard: {
    slugConfig: {
      dayPass: "theyard-day-pass",
      multiPass: "theyard-multi-pass",
      creditPackages: "theyard-credit-packages",
      meetingRooms: "theyard-meeting-rooms",
    },
  },
  Urbanplace: {
    slugConfig: {
      dayPass: "urbanplace-day-pass",
      dayDeskPass: "urbanplace-day-desk-pass",
      dayOffice: "urbanplace-day-office-pass",
      multiPass: "urbanplace-multi-pass",
      deskMultiPass: "urbanplace-desk-multi-pass",
      meetingRooms: "urbanplace-meeting-rooms",
      productCatalog: "urbanplace",
      officeMultiPass: "urbanplace-office-multi-pass",
    },
  },
  TheMalin: {
    slugConfig: {
      dayPass: "the-malin-day-pass",
      multiPass: "the-malin-multi-pass",
      dedicatedDeskMultiPass: "the-malin-dedicated-desk-multi",
      meetingRooms: "the-malin-meeting-rooms",
      dailyDeskPass: "the-malin-daily-desk-pass",
      monthlyAccess: "the-malin-monthly-access-pass",
    },
  },
  Cubico: {
    slugConfig: {
      dayPass: "cubico-day-pass",
      multiPass: "cubico-multi-pass",
      dailyOffice: "cubico-daily-office",
      productCatalog: "cubico",
    },
  },
  Luminary: {
    slugConfig: {
      dayPass: "luminary-day-pass",
      multiPass: "luminary-multi-pass",
      meetingRooms: "luminary-meeting-rooms",
      dayOffice: "luminary-day-office",
      multiDayOffice: "luminary-multi-day-office",
      productCatalog: "luminary",
    },
  },
  DiwanHub: {
    slugConfig: {
      dayPass: "diwan-hub-day-pass",
      multiPass: "diwan-hub-multi-pass",
      meetingRooms: "diwan-hub-meeting-rooms",
      productCatalog: "diwan-hub",
    },
  },
  Teamworking: {
    slugConfig: {
      dayPass: "teamworking-day-pass",
      multiPass: "teamworking-multi-pass",
      productCatalog: "teamworking",
    },
  },
  MDot: {
    slugConfig: {
      dayPass: "mdot-day-pass",
      multiPass: "mdot-multi-pass",
      dayOffice: "mdot-day-office",
      meetingRooms: "mdot-meeting-rooms",
    },
  },
  MercuryCenter: {
    slugConfig: {
      dayPass: "mercury-center-day-pass",
      multiPass: "mercury-center-multi-pass",
      dayOffice: "mercury-center-day-office",
      meetingRooms: "mercury-center-meeting-rooms",
    },
  },
  BondCollective: {
    slugConfig: {
      dayPass: "bond-collective-day-pass",
    },
  },
  CoalitionSpace: {
    slugConfig: {
      dayPass: "coalition-space-day-pass",
      multiPass: "coalition-space-multi-pass",
      meetingRooms: "coalition-space-meeting-rooms",
    },
  },
  Rooms: {
    slugConfig: {
      // TODO: clean up dayPass and multiPass
      dayPass: "rooms-day-pass",
      multiPass: "rooms-multi-day-pass",
      dailyAccess: "rooms-daily-access",
      dayOffice: "rooms-day-office",
      executiveOffice: "rooms-executive-office",
      meetingRooms: "rooms-meeting-rooms",
    },
  },
  FoundrSpace: {
    slugConfig: {
      dayPass: "foundrspace-day-pass",
      dailyDeskPass: "foundrspace-daily-desk-pass",
      multiPass: "foundrspace-multi",
      meetingRooms: "foundrspace-meeting-rooms",
      dayOffice: "foundrspace-day-office",
    },
  },
  Rentry: {
    slugConfig: {
      dayPass: "rentry-day-pass",
      dayDeskPass: "rentry-day-desk-pass",
      multiPass: "rentry-multi",
      meetingRooms: "rentry-meeting-rooms",
    },
  },
  VillageWorkspaces: {
    slugConfig: {
      dayPass: "village-workspaces-day-pass",
      multiPass: "village-workspaces-multi",
      meetingRooms: "village-workspaces-meeting-rooms",
      dayOffice: "village-workspaces-day-office",
      multiDayOffice: "village-workspaces-multi-day-office",
    },
  },
  MindWareHouse: {
    slugConfig: {
      dayPass: "mindwarehouse-day-pass",
      dayOffice: "mindwarehouse-day-office",
      multiPass: "mindwarehouse-multi",
      meetingRooms: "mindwarehouse-meeting-rooms",
    },
  },
  EthosSociety: {
    slugConfig: {
      dayPass: "ethos-society-day-pass",
      dayOffice: "ethos-society-day-office",
      multiPass: "ethos-society-multi",
      meetingRooms: "ethos-society-meeting-rooms",
    },
  },
  BeyondPostal: {
    slugConfig: {
      dayPass: "beyond-postal-day-pass",
      multiPass: "beyond-postal-multi",
      meetingRooms: "beyond-postal-meeting-rooms",
    },
  },
  Trellis: {
    slugConfig: {
      dayPass: "trellis-day-pass",
      dayOffice: "trellis-day-office",
      multiPass: "trellis-multi-pass",
      meetingRooms: "trellis-meeting-rooms",
    },
  },
} as const;
